export default "__VITE_ASSET__Coe4Qers__"